export const TMW = {};
TMW.NEW_TEAM_WORKMODAL = "NEW_TEAM_WORKMODAL";
TMW.CLOSE_NEW_TEAM_WORKMODAL = "CLOSE_NEW_TEAM_WORKMODAL";
TMW.ADD_NEW_USER_MODAL = "ADD_NEW_USER_MODAL";
TMW.CLOSE_ADD_NEW_USER_MODAL = "CLOSE_ADD_NEW_USER_MODAL";
TMW.ADD_RULE_MODAL = "ADD_RULE_MODAL";
TMW.CLOSE_ADD_RULE_MODAL = "CLOSE_ADD_RULE_MODAL";
TMW.ADD_PRODUCT_GROUPS_MODAL = "ADD_PRODUCT_GROUPS_MODAL";
TMW.CLOSE_ADD_PRODUCT_GROUPS_MODAL = "CLOSE_ADD_PRODUCT_GROUPS_MODAL";
TMW.UPDATE_CONTRACTS = "UPDATE_CONTRACTS";
TMW.CREATE_NEW_TEAM_WORK = "CREATE_NEW_TEAM_WORK";

TMW.SELECT_CONTRACT = "SELECT_CONTRACT";
TMW.CANCEL_SELECT_CONTRACT = "CANCEL_SELECT_CONTRACT";
TMW.UPDATE_USERS_LIST = "UPDATE_USERS_LIST";
TMW.UPDATE_TEAM_WORKS = "UPDATE_TEAM_WORKS";
TMW.UPDATE_SELECTED_USERS_LIST = "UPDATE_SELECTED_USERS_LIST";
TMW.UPDATE_TEAMWORK_INFO = "UPDATE_TEAMWORK_INFO";
TMW.USER_PERMISSON_INITIAL_STATE = "USER_PERMISSON_INITIAL_STATE";
TMW.UPDATE_SELECTED_TEAMWORK = "UPDATE_SELECTED_TEAMWORK";
TMW.UPDATE_ADDED_NEW_USERS = "UPDATE_ADDED_NEW_USERS";
TMW.UPDATE_SELECTED_PRODUCT_GROUPS_ITEMS =
  "UPDATE_SELECTED_PRODUCT_GROUPS_ITEMS";
//TeamWork Nav
  TMW.WORK_GROUPS_MANAGEMENT_MODAL = "WORK_GROUPS_MANAGEMENT_MODAL";
  TMW.CHANGE_TEAM_WORK_START = "CHANGE_TEAM_WORK_START";
  TMW.CHANGE_TEAM_WORK_END = "CHANGE_TEAM_WORK_END";
  TMW.CONFIRM_WORKGROUPS_MANAGEMENT_MODAL ="CONFIRM_WORKGROUPS_MANAGEMENT_MODAL"
  TMW.SET_CURRENT_TEAMWORK_DASHBOARD ="SET_CURRENT_TEAMWORK_DASHBOARD"

//Document Group Limitation-------------------------------------------------------
TMW.SET_USER_DOCUMENTGROUP ="SET_USER_DOCUMENTGROUP"
TMW.CLOSE_USER_DOCUMENTGROUP = "CLOSE_USER_DOCUMENTGROUP"
//Product Group Limitation-------------------------------------------------------
TMW.SET_USER_PRODUCTGROUP ="SET_USER_PRODUCTGROUP"
TMW.CLOSE_USER_PRODUCTGROUP = "CLOSE_USER_PRODUCTGROUP"
//Operation Group Limitation-------------------------------------------------------
TMW.SET_USER_OPERATIONGROUP ="SET_USER_OPERATIONGROUP"
TMW.CLOSE_USER_OPERATIONGROUP = "CLOSE_USER_OPERATIONGROUP"



